<template>
  <p>{{ text }}</p>
</template>

<script>
export default {
  name: "MainText",
  props: {
    text: String,
  },
};
</script>

<style scoped>
p {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: #212325;
}
.title {
  font-size: 35px;
  font-weight: bold;
  margin-top: 30px;
  margin-bottom: 30px;
}
.content {
  font-size: 20px;
}
</style>